<template>
  <Modal
    v-model="_value"
    width="500"
    title="下载两客一危一重某天轨迹"
    @on-visible-change="visibleChange"
    ok-text="确认处理"
    @on-ok="onOk"
    cancel-text="关闭">
    <Form  :label-width="80">
      <FormItem prop="selectTime">
        <DatePicker size="small" type="date" v-model="selectDownloadDatetime" placeholder="选择日期"
                    style="margin-right: 3px; width: 200px;"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'downloadgddlysjglocatehistorymodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      selectDownloadDatetime: null,
    }
  },
  methods: {
    ...mapActions([
      'GdDlysjgLocateHistoryServ_DownloadDailyTracksByCreateDatetime',
      'AlarmAnalysisServ_GetDetail'
    ]),
    onOk () {
      console.log('onOk')
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认下载</p>',
        onOk: () => {
          if (!this.selectDownloadDatetime) {
            this.$Message.error('无效时间')
            return
          }
          let selectDatetime = new Date(this.selectDownloadDatetime).Format('yyyy-MM-dd 00:00:00')
          store.dispatch('GdDlysjgLocateHistoryServ_DownloadDailyTracksByCreateDatetime', {
            params: { selectDatetime: selectDatetime}
          }).then(() => {
            this.$Message.success('开始下载')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.selectDownloadDatetime = new Date()
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
